import { isArray, isObject, isString, uniq } from 'lodash';
import VerticalCertingModel from './vertical-certing.model';
import { momentInstance } from 'helpers/date-time';

class UserModel {
  static parseRequestUpdateUser(values, { isUpdate } = {}) {
    const {
      email,
      firstname,
      lastname,
      phoneType,
      speed,
      statusName,
      // role,
      roles,
      address1,
      address2,
      city,
      state,
      timeName,
      zip,
      gender,
      phone,
      referrerId,
      company,
      companyDesc,
      companyPhone,
      industry,
      opHours,
      apiRequestKey,
      note,
      linkAccountUser,
      showCreditUser,
      showBTEmailUser,
      activateCreditPooling,
      enableCreditPooling,
      useAgencyCredit,
      hasActivatedEmailLink,
      hasActivatedText,
      country,
      twoWay,
      agentAcc,
      enableAutoScrub,
      skipScrubDNC,
      skipScrubLandline,
      enableDummyCampaign,
      enableMaskPhoneNumberByMd5,
      liveFeedForward,
      limitNumberMessagePerDay,
      failoverRouteEnable,
      failoverRouteId,
      dataConsumerEnabled,
      apiRateLimit,
      enableViewRevenue,
      disableSms,
      disableMms,
      preventMovingDidDuringCampaign,
      routes,
      domainVendor,
      enableSavingFilteredLead,
      chkDontShowInbox,

      billingAddress,
      billingName,
      billingCountry,
      billingRegNo,
      billingVatNo,

      exportContactSeedNumber,
      financialName,
      referralCode,
      enableContactCerting,
      verticalCertingSiteMapping,
      enableMultiPartMessage,
      enableDidScrub,
      simpleFullfillment,
      enableCreditCard,
    } = values;

    const result = {
      email: email?.trim(),
      firstname: firstname?.trim(),
      lastname: lastname?.trim(),
      phone,
      speed,
      isDelPhone: false,
      statusName,
      role: roles,
      // roles,
      address1,
      address2,
      city,
      state,
      timeName,
      zip,
      country,
      genderName: gender === 'm' ? 'Male' : 'Female',
      referrerId,
      phoneType,
      company,
      companyDesc,
      companyPhone,
      industry,
      opHours,
      apiKey: apiRequestKey,
      note,
      linkAccountUser,
      showCreditUser,
      showBTEmailUser,
      activateCreditPooling,
      enableCreditPooling,
      useAgencyCredit,
      hasActivatedEmailLink,
      hasActivatedText,
      twoWay,
      enableAutoScrub,
      skipScrubDNC,
      skipScrubLandline,
      enableDummyCampaign,
      enableMaskPhoneNumberByMd5,
      enableContactCerting,
      liveFeedForward,
      agentAcc: agentAcc ? agentAcc.trim() : agentAcc,
      limitNumberMessagePerDay,
      // linkedAgencyForCreditPooling: ? string: ?
      failoverRouteEnable,
      failoverRouteId: isObject(failoverRouteId)
        ? failoverRouteId?.value
        : !!failoverRouteId
        ? failoverRouteId
        : undefined,
      dataConsumerEnabled,
      apiRateLimit,
      enableViewRevenue,
      disableMms,
      disableSms,
      preventMovingDidDuringCampaign,
      routes: isArray(routes) ? routes.map((el) => el.id).join(',') : '',
      domainVendor,
      enableSavingFilteredLead,
      chkDontShowInbox,

      billingAddress,
      billingName,
      billingCountry,
      billingRegNo,
      billingVatNo,

      exportContactSeedNumber: isString(exportContactSeedNumber)
        ? exportContactSeedNumber
            .trim()
            .split(',')
            .filter((el) => !!el)
            .map((el) => el.replaceAll(' ', ''))
            .join(',')
        : '',

      financialName,
      subscriptionProfile: values?.subscriptionProfile || '',
      referralCode: isUpdate ? undefined : referralCode,
      verticalCertingSiteMapping: enableContactCerting
        ? JSON.stringify(VerticalCertingModel.parseRequestFromListToObj(verticalCertingSiteMapping))
        : JSON.stringify({}),
      enableMultiPartMessage,
      enableDidScrub,

      skipScrubBlaDNC: values?.skipScrubBlaDNC,
      skipScrubTBBlacklist: values?.skipScrubTBBlacklist,
      skipScrubTBMd5Blacklist: values?.skipScrubTBMd5Blacklist,
      skipScrubTBGlobalDNC: values?.skipScrubTBGlobalDNC,
      skipScrubTB10DlcOptout: values?.skipScrubTB10DlcOptout,

      enableCAInternationalScrubbing: values?.enableCAInternationalScrubbing,
      accountManagerAcc: values?.accountManagerAcc?.label || '',

      enableRndScrub: values?.enableRndScrub,
      rndScrubCarriers: !!values?.enableRndScrub
        ? isArray(values?.rndScrubCarriers)
          ? JSON.stringify(values?.rndScrubCarriers.map((el) => el.value.trim()))
          : []
        : [],
      rndScrubStartDate: !!values?.enableRndScrub
        ? values?.rndScrubStartDate
          ? momentInstance(values?.rndScrubStartDate).format('YYYY-MM-DD')
          : null
        : null,
      callDeliveredLimitPerVertical: values.callDeliveredLimitPerVertical,
      simpleFullfillment,
      enableCreditCard,
      enableCheckNotUsedDids: values?.enableCheckNotUsedDids,
      bannedWords: values?.bannedWords,
    };

    return result;
  }

  static mappingLabelBillingInfo(field) {
    const mapping = {
      billingAddress: 'Address',
      billingName: 'Name',
      billingCountry: 'Country',
      billingRegNo: 'Reg. No.',
      billingVatNo: 'VAT. No.',
      billingIBAN: 'International Bank Account Number',
      billingBIC: 'BIC (Business Identifier Code) / SWIFT CODE',
      billingIntermediaryBIC: 'Intermediary BIC',
      billingBank: 'Bank',
      billingBankAddress: 'Bank address',
      entityName: 'Entity name',
    };

    return mapping?.[field] || '';
  }

  static detectRoutesBeDeleted = (initialRoutes, currentRoutes) => {
    const transformByIdRoute = (routes) =>
      isArray(routes) ? uniq(routes.map((el) => el.id)).sort((a, b) => a - b) : [];

    const initialIdRoutes = transformByIdRoute(initialRoutes);
    const currentIdRoutes = transformByIdRoute(currentRoutes);

    const foundRouteDeleted = initialIdRoutes.some((routeId) => !currentIdRoutes.includes(routeId));
    return foundRouteDeleted;
  };
}

export default UserModel;
